export default "__VITE_ASSET__BwUv1vDa__"